import React, { useState } from 'react';

import {
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from '@material-ui/lab';

import { ApplicantMessageTemplateParser } from '../../../message-templates/parsers/applicant-message-template-parser';
import { StyledTimelineItem } from '../ui/styled-timeline';

import { ApplicantAutomationDialog } from './applicant-automation-dialog';
import { AutomationWarning } from './automation-warning';

import { ICON_NAMES, MaterialDesignIcon } from '../../../util/material-design-icons';
import { APPLICANT_AUTOMATION_COMMUNICATION_TYPES } from '../../utils/applicant-automation-communication-types';
import { AutomationsByTriggerDictionary } from '../../utils/applicant-automation-display-utils';

export const MissingInterestConfirmationWarning = ({
  parserJob,
  user,
  org,
  editingForJob,
  parentAutomationsForSection,
}: {
  parserJob?: Job;
  user?: AuthenticatedUser;
  org: Org;
  editingForJob?: Job;
  parentAutomationsForSection?: AutomationsByTriggerDictionary;
}) => {
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);

  const toggleDialog = () => setDialogVisible(!dialogVisible);

  const getParser = () =>
    new ApplicantMessageTemplateParser({
      useStandInApplicant: true,
      job: parserJob,
      useStandInJob: !parserJob,
      org,
      user,
    });

  return (
    <>
      <StyledTimelineItem>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot>
            <MaterialDesignIcon iconName={ICON_NAMES.PRIORITY_HIGH} size="xs" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <div className="u-margin-x-2x u-width-100 u-flex-center">
            <AutomationWarning
              className="u-width-100"
              missingFieldIssue={{
                object: editingForJob ? 'This job' : 'Some jobs',
                field: 'active interest confirmations',
                reason: 'applicant filter settings',
              }}
              action={toggleDialog}
              variant="automationIssue"
            />
            <div
              key="applicant-automation-timeline-item-spacer"
              className="u-width-30px u-margin-left-lg"
            />
          </div>
        </TimelineContent>
      </StyledTimelineItem>
      {dialogVisible && (
        <ApplicantAutomationDialog
          key="creating-automation-application"
          section="application"
          orgId={org.org_id}
          orgName={org.name}
          parser={getParser()}
          onClose={toggleDialog}
          editingForJob={editingForJob}
          parentAutomationsForSection={parentAutomationsForSection}
          addingAutomationForTrigger={
            APPLICANT_AUTOMATION_COMMUNICATION_TYPES.INTEREST_CONFIRMATION
          }
        />
      )}
    </>
  );
};
